export const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'MAD', symbol: 'DH', name: 'Moroccan Dirham' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' }
]

export function currencySymbol(code) {
  const found = CURRENCIES.find((c) => c.code === code)
  return (found && found.symbol) || '$'
}

export function formatCurrency(amount, code = 'USD', opts = {}) {
  try {
    const fmt = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code,
      currencyDisplay: 'symbol',
      ...opts
    })
    return fmt.format(Number(amount || 0))
  } catch (e) {
    // Fallback simple format with symbol
    const sym = currencySymbol(code)
    const num = isNaN(amount) ? 0 : Number(amount)
    return `${sym}${num.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`
  }
}
